import * as React from 'react';
import { Area, AreaChart, XAxis, YAxis } from 'recharts/lib';
import Data from '../../../../../services/Data';
import { GetMaxLevelForMode } from '../../../../../services/Game/GameMode/GameMode';

const MountainGraph = ({ currentLevel }: { currentLevel: number }) => {
    let data = [];
    const maxLevel = GetMaxLevelForMode(currentLevel);
    for (let level = 1; level <= maxLevel; level++) {
        const kipsNeeded = Data.GetKipsToReachLevel(level);
        data.push({
            Level: level,
            kipsNeeded,
            kipsAchieved: currentLevel >= level ? kipsNeeded : 0
        });
    };

    return (
        <div>
            <AreaChart width={260} height={280} data={data}
                margin={{top: 10, right: 30, left: 0, bottom: 0}}>
                <XAxis dataKey="Level" interval={10} />
                <YAxis type="number" domain={[0, 'dataMax']} />
                <Area type='monotone' dataKey='kipsNeeded' stroke='#8884d8' fill='#8884d8' />
                <Area type='monotone' dataKey='kipsAchieved' stroke='#ffd700' fill='#ffd700' />
            </AreaChart>        
        </div>
    );
}

export default MountainGraph;
